export enum TicketStatus {
    Complete = 1,
    Closed = 1,
    InComplete =2,
    Void =3
}
